import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

const DOC = gql`
  query SpaceFilterOptions(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $entityId: ID!
    $ancestorEntityId: ID
    $ancestorIds: [ID]
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceFilterOptions(
                  entityId: $entityId
                  ancestorEntityId: $ancestorEntityId
                  ancestorIds: $ancestorIds
                ) {
                  code
                  id
                  name
                  prefix
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.SpaceFilterOptionsQuery,
    readonly ents.extra.space.Filter.Option[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'spaceFilterOptions',
                graphql.transformers.OUT.default(
                  graphql.transformers.OUT.list(
                    graphql.transformers.OUT.object({
                      code: graphql.transformers.OUT.nonNull(
                        transformers.PASS_THROUGH,
                      ),
                      id: graphql.transformers.OUT.validate(
                        transformers.PASS_THROUGH,
                        ents.core.dms.data.Record.Id.assertIsId,
                      ),
                      name: graphql.transformers.OUT.nonNull(
                        transformers.PASS_THROUGH,
                      ),
                      prefix: transformers.PASS_THROUGH,
                    }),
                    { onNullish: 'remove' },
                  ),
                  [],
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.SpaceFilterOptionsQuery,
  readonly ents.extra.space.Filter.Option[],
  graphql.schema.SpaceFilterOptionsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
